// New versions arrive by themselves. The service worker fetches an update in the background and takes
// over at once (skipWaiting, clientsClaim); the page switches to it only at a quiet moment, so nobody is
// interrupted: within a few seconds of opening (or of coming back after a break) and before the screen has
// been touched. An update found later waits for the next quiet moment, or the next time Ahillah opens.

export const QUIET_MS = 8000;
export const BREAK_MS = 10 * 60e3;

/** Whether the page may switch to a new version now. */
export const isQuiet = (openedAt: number, now: number, touched: boolean) => !touched && now - openedAt < QUIET_MS;

export function watchForUpdates() {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  // The address as opened: a link's details (a pass to show, a panel) are taken out of it once used, and a
  // switch straight after opening must open the same thing again.
  let opened = location.href;
  // With no worker in charge yet this is the first visit: its worker taking over is not an update.
  const hadController = !!navigator.serviceWorker.controller;
  let openedAt = performance.now();
  let touched = false;
  let waiting = false;
  let hiddenAt = 0;
  const touch = () => (touched = true);
  addEventListener('pointerdown', touch, { capture: true, passive: true });
  addEventListener('keydown', touch, { capture: true });
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController) return;
    if (isQuiet(openedAt, performance.now(), touched)) location.replace(opened);
    else waiting = true;
  });
  const register = () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((reg) => {
      const check = () => void reg.update().catch(() => {});
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          hiddenAt = Date.now();
          return;
        }
        if (hiddenAt && Date.now() - hiddenAt > BREAK_MS) {
          // Back after a break: as good as opening again.
          if (waiting) return location.reload();
          openedAt = performance.now();
          touched = false;
          opened = location.href;
        }
        check();
      });
      setInterval(check, 60 * 60e3);
    }, () => {});
  };
  if (document.readyState === 'complete') register();
  else addEventListener('load', register);
}
